import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "bg-modal",
  style: {"width":"30vw"}
}
const _hoisted_2 = { class: "row-top" }
const _hoisted_3 = {
  class: "pad-m",
  style: {"padding-top":"0"}
}

import { ref, watch, computed, onBeforeUnmount } from 'vue'
import { useAppUserStore } from '@/stores/appUser'
import { useCurrentEntryStore } from '@/stores/currentEntry'
import { useI18n } from 'vue-i18n'


export default /*@__PURE__*/_defineComponent({
  __name: 'editPosologyPreference',
  props: {
  sctSubstanceKey: {
    type: String,
    required: false,
  },
  suggestedFavorite: {
    type: String,
    default: '',
  },
},
  emits: ['saveSuggestions'],
  setup(__props, { emit: __emit }) {

const appUserStore = useAppUserStore()
const currentEntryStore = useCurrentEntryStore()
const { t } = useI18n()

const emits = __emit
const props = __props;

const textSuggestions = ref('')
const substanceSuggestions = ref('')

const textFavorite = computed(() => {
  const suggestions = appUserStore.currentAppUserData.preferences.medicationSuggestions || [];
  const match = suggestions.find(item => item.originalText === currentEntryStore.poppedSapNewName);
  return match || null;
})

const substanceFavorite = computed(() => {
  const suggestions = appUserStore.currentAppUserData.preferences.medicationSuggestions || [];
  if (props.sctSubstanceKey && !textFavorite.value) {
    const match = suggestions.find(item => item.sctSubstanceKey === props.sctSubstanceKey);
    return match || null;
  }
  return null;
})

function addSuggestedFavorite() {
  if (!props.suggestedFavorite) return
  const newSuggestion = props.suggestedFavorite.trim()
  const existingSuggestions = textSuggestions.value.trim()
  const isNewSuggestionMultiLine = newSuggestion.includes('\n')
  const isExistingSuggestionsMultiLine = existingSuggestions.includes('---') || existingSuggestions.includes('\n')
  const needsBlockMode = isNewSuggestionMultiLine || isExistingSuggestionsMultiLine
  if (!existingSuggestions) {
    const prefix = needsBlockMode ? '---\n' : ''
    textSuggestions.value = prefix + newSuggestion
    return
  }
  if (!needsBlockMode) {
    textSuggestions.value = existingSuggestions + '\n' + newSuggestion
    return
  }
  const hasBlankLineBeforeSeparator = /\n\s*\n\s*---/.test(existingSuggestions)
  const separator = hasBlankLineBeforeSeparator ? '\n\n---\n' : '\n---\n'
  textSuggestions.value = existingSuggestions + separator + newSuggestion
}

watch(textFavorite, (val) => {
  textSuggestions.value = val?.suggestions || ''
}, { immediate: true })

watch(substanceFavorite, (val) => {
  substanceSuggestions.value = val?.suggestions || ''
}, { immediate: true })

onBeforeUnmount(() => {
  const originalTextSuggestions = textFavorite.value?.suggestions || '';
  const originalSubstanceSuggestions = substanceFavorite.value?.suggestions || '';

  const basePayload = {
    originalText: currentEntryStore.poppedSapNewName,
    expressionId: currentEntryStore.poppedSapExpr.expressionId
  }

  // Suggestions
  if (textSuggestions.value !== originalTextSuggestions && (textFavorite.value || textSuggestions.value.trim())) {
    emits('saveSuggestions', { ...basePayload, newSuggestions: textSuggestions.value })
  }
  if (substanceSuggestions.value !== originalSubstanceSuggestions && substanceFavorite.value) {
    emits('saveSuggestions', { ...basePayload, newSuggestions: substanceSuggestions.value })
  }

})

return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_buttonGroup = _resolveComponent("buttonGroup")!
  const _component_inputAreaAuto2 = _resolveComponent("inputAreaAuto2")!
  const _component_inputBox = _resolveComponent("inputBox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_text_item, {
          txt: _unref(currentEntryStore).poppedSapNewName,
          styles: "font-l"
        }, null, 8, ["txt"])
      ]),
      (__props.suggestedFavorite)
        ? (_openBlock(), _createBlock(_component_buttonGroup, {
            key: 0,
            styles: "pad-s border-m",
            class: "mtop-02 mleft-auto psides-04",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (addSuggestedFavorite()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_svg_item, {
                icon: "plus",
                styles: "size-m main-m",
                style: {"margin-top":"0.1rem"}
              }),
              _createVNode(_component_text_item, {
                txt: _unref(t)('patient.pharmacy.posology.preference.addCurrentDose'),
                styles: "font-mBold main-m",
                class: "mleft-02"
              }, null, 8, ["txt"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_inputBox, { class: "mtop-02" }, {
      default: _withCtx(() => [
        _createVNode(_component_inputAreaAuto2, {
          lines: 10,
          modelValue: textSuggestions.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((textSuggestions).value = $event)),
          placeholder: substanceFavorite.value ? _unref(t)('patient.pharmacy.posology.preference.emptyToUseSubstance') : _unref(t)('patient.pharmacy.posology.preference.addPosologies')
        }, null, 8, ["modelValue", "placeholder"])
      ]),
      _: 1
    }),
    (substanceFavorite.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_text_item, {
            txt: substanceFavorite.value.originalText,
            styles: "font-l",
            class: "mleft-02 mtop-10"
          }, null, 8, ["txt"]),
          _createVNode(_component_text_item, {
            txt: _unref(t)('patient.pharmacy.posology.preference.posologies'),
            styles: "font-mBold",
            class: "mleft-02 mtop-10"
          }, null, 8, ["txt"]),
          _createVNode(_component_inputBox, { class: "mtop-02" }, {
            default: _withCtx(() => [
              _createVNode(_component_inputAreaAuto2, {
                lines: 10,
                modelValue: substanceSuggestions.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((substanceSuggestions).value = $event)),
                placeholder: _unref(t)('patient.pharmacy.posology.preference.posologiesPlaceholder')
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          })
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})